import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Navbar from "../components/organisms/Navbar";
import Breadcrumb from "../components/molecules/Breadcrumb";
import routes from './routes';

function Router() {

    const token = useSelector(state => state.auth.token);

    return (
        <Routes>
            {
                routes.map(routeItem => {
                    const { path, exact, element, isPrivate } = routeItem;

                    const RenderPrivateRouteElement = () => {
                        if (token) {
                            return (
                                <div className="app-container">
                                    <Navbar />
                                    <Breadcrumb />
                                    {element}
                                </div>
                            );
                        } 

                        return (<Navigate to="/" />)
                    }

                    if (isPrivate) {
                        return (
                            <Route
                                key={path}
                                path={path} 
                                exact={exact}
                                element={<RenderPrivateRouteElement />}
                            />
                        )
                    }
                    
                    return <Route key={path} path={path} exact={exact} element={element} />
                })
            }
        </Routes>
    );
}

export default Router;